export function heurekaPurchase(order) {
  if (order && Object.keys(order).length !== 0 && window._hrq) {
    window._hrq.push(['setOrderId', `${order.order_id}`]);

    if (order.items && order.items.length) {
      order.items.map(item => {
        window._hrq.push([
          'addProduct',
          item.product_name,
          `${item.totalprice}`,
          `${item.quantity}`,
          `${item.product_id}`,
        ]);
      });
    }
    window._hrq.push(['trackOrder']);

    if (window.trackHeurekaOrder) {
      window.trackHeurekaOrder();
    }
  }
}
/**
 * Heureka purchase tracking - https://sluzby.heureka.sk/napoveda/mereni-konverzi/
 * @param order Order object
 * @param clinetId Heureka client ID
 */
export function heurekaPurchaseNew(order, clinetId) {
  if (window.trackHeurekaOrderNew) {
    window.trackHeurekaOrderNew();
  }

  if (order && Object.keys(order).length !== 0 && window.heureka) {
    window.heureka('authenticate', clinetId);

    window.heureka('set_order_id', order.vs);

    let totalItemsPrice = 0;

    if (order.items && order.items.length) {
      order.items.map(item => {
        if (item.is_meta_item) {
          return;
        }

        const itemTotal = item.unitprice * item.quantity;
        totalItemsPrice += itemTotal;

        window.heureka(
          'add_product',
          item.product_id,
          item.product_name,
          item.unitprice,
          item.quantity,
        );
      });
    }

    window.heureka('set_total_vat', totalItemsPrice); // Total order price without shipping and payment
    window.heureka('set_currency', order.order_tpricecurrency);
    window.heureka('send', 'Order');
  }
}
